import React, { useState } from "react";
import NewLogin from "./NewLogin";
import EmailSuccess from "./NewEmailSuccessPage";
import NewLogin1 from "./NewLogin1";
import NewEmailSuccessPage1 from "./NewEmailSuccessPage1";

const LoginComponent = ({ selectedLanguage, isWhiteLabel, logoutReason }) => {
  const [emailVerified, setEmailVerified] = useState(false);
  const [isV2AuthEnabled, setIsV2AuthEnabled] = useState(false);
  const [mailId, setMailId] = useState("");

  const verifiedMail = (emailId) => {
    setMailId(emailId);
  };
  const setEmailFalse = () => {
    setEmailVerified(false);
  };

  const setEmailTrue = () => {
    setEmailVerified(true);
  };

  return (
    <div>
      {!emailVerified && !isWhiteLabel && (
        <NewLogin1
          loginTrue={setEmailTrue}
          mailId={mailId}
          setMail={verifiedMail}
          selectedLanguage={selectedLanguage}
          setV2AuthEnabled={setIsV2AuthEnabled}
          logoutReason={logoutReason}
        />
      )}
      {emailVerified && !isWhiteLabel && (
        <NewEmailSuccessPage1
          loginTrue={setEmailFalse}
          setMail={verifiedMail}
          mailId={mailId}
          selectedLanguage={selectedLanguage}
          isV2AuthEnabled={isV2AuthEnabled}
        ></NewEmailSuccessPage1>
      )}

      {!emailVerified && isWhiteLabel && (
        <NewLogin
          loginTrue={setEmailTrue}
          mailId={mailId}
          setMail={verifiedMail}
          selectedLanguage={selectedLanguage}
          setV2AuthEnabled={setIsV2AuthEnabled}
        />
      )}
      {emailVerified && isWhiteLabel && (
        <EmailSuccess
          loginTrue={setEmailFalse}
          setMail={verifiedMail}
          mailId={mailId}
          selectedLanguage={selectedLanguage}
          isV2AuthEnabled={isV2AuthEnabled}
        ></EmailSuccess>
      )}
    </div>
  );
};

export default LoginComponent;
